export default {
    about_doctor: "О докторе",
    account_manager: "Аккаунт менеджер",
    activated: "Активировано",
    additional_info: "Дополнительная информация",
    administrator: "Администратор",
    administrators: "Администраторы",
    amount_of_doctors: "Кол-во врачей",
    are_you_sure_you_want_to_delete_field: "Вы уверены, что хотите удалить направление",
    assistants: "Ассистенты",
    backup_code: "Резервный код",
    block: "Заблокировать",
    block_noun: "Блок",
    browse_computer: "Выбрать из файлов",
    by_cabinets: "По кабинетам",
    by_days: "По дням",
    by_days_of_week: "По дням недели",
    by_even_days: "По четным дням",
    by_odd_days: "По нечетным дням",
    cabinet: "Кабинет",
    cabinets: "Кабинеты",
    chair: "Кресло",
    chairs: "Кресла",
    clinic_access_request: "Запрос доступа к клинике",
    config: "Конфигурация",
    confirm_password: "Повторить пароль",
    curator: "Куратор",
    curators: "Кураторы",
    dentist_plus_tech_support_requests_access_to_your_clinic: "Техническая поддержка Dentist+ запрашивает доступ к вашей клинике",
    doctor_position: "Должность врача",
    doctor_specialty: "Специальность врача",
    enter_backup_code_note: "Введите один из резервных кодов, который вы получали при активации двухфакторной аутентификации. Обратите внимание, что каждый резервный код может использоваться только единожды",
    enter_code_from_authorization_app: "Введите код из приложения двухфакторной авторизации у вас на телефоне",
    field: "Направление",
    fields: "Направления",
    functionality: "Функционал",
    login_and_password: "Логин и пароль",
    manual_pay_system: "Ручная платежная система",
    not_worked: "Не отработано",
    partner: "Партнер",
    password_does_not_match_confirmation: "Пароль не совпадает с подтверждением",
    password_requirement_min_length: "Не менее {min} символов",
    password_requirement_mixed_case: "Латинские буквы в верхнем и нижнем регистре",
    password_requirement_number: "Обязательно цифра",
    password_requirement_symbol: "Обязательно спец. символ",
    percent: "Процент",
    period_from: "Период с",
    period_to: "Период до",
    phone2: "Телефон 2",
    profession: "Специальность",
    rate: "Ставка",
    rate_per_day: "Ставка в день",
    rate_per_hour: "Ставка в час",
    rate_per_month: "Ставка в месяц",
    reserve_codes: "Резервные коды",
    roles: "Роли",
    sale_good_percent: "Процент с продажи товаров",
    schedule_config_delete_confirmation: "Вы уверены, что хотите удалить конфигурацию расписания?",
    schedule_conflicts_found: "Найдено конфликтов расписания с текущими записями",
    seller: "Продавец",
    staff: "Персонал",
    take_photo: "Сделать фото",
    technics: "Техники",
    turn_on: "Включить",
    turned_off: "Отключено",
    two_factor_authorization: "Двухфакторная авторизация",
    two_factor_authorization_setup_successfully: "Двухфакторная авторизация активирована успешно",
    twofactor_setup_instructions: "<ul><li>Скачайте приложение-аутентификатор (например, Google Authenticator, Microsoft Authenticator, Яндекс.Ключ) из App Store или Google Play.</li><li>Нажмите 'Добавить код'/'+' в приложении на телефоне и отсканируйте QR-код, отображаемый на экране компьютера.</li><li>Введите 6-значный код, сгенерированный приложением, в соответствующее поле под qr кодом для завершения привязки</li><li>Обязательно сохраните предложенные резервные коды (появятся после проверки 6-значного кода) в безопасном месте на случай потери телефона</li></ul>",
    use_app_code: "Использовать стандартный код",
    use_backup_code: "Использовать резервный код",
    user_data: "Данные пользователя",
    user_will_assigned_rights_selected_for_that_role: "Пользователю будут назначены права, выбранные для этой роли",
    weekend: "Выходной",
    without_warehouse_form_note: "Без привязки к складу, материалы будут списываться с основного склада или со склада, привязанного к креслу",
    work_day: "Рабочий день",
    work_days: "Рабочие дни",
    work_schedule: "График работы",
    work_time: "Рабочее время",
    worked: "Отработано"
}
